export default __webpack_public_path__ + "static/media/add-new-project.89d75104.svg";